import { Component, OnInit, HostListener } from '@angular/core';
import { AuthUserDetailsComponent } from './authentication/auth-user-details/auth-user-details.component';
import { ModalService, ModalcloseReason } from 'hsg';
import { AuthUserOtpComponent } from './authentication/auth-user-otp/auth-user-otp.component';
import { AuthIssueDateComponent } from './authentication/auth-issue-date/auth-issue-date.component';
import { AuthAuthenticateMethodComponent } from './authentication/auth-authenticate-method/auth-authenticate-method.component';
import { AuthChangePasswordComponent } from './authentication/auth-change-password/auth-change-password.component';
import { AuthCreditCardComponent } from './authentication/auth-credit-card/auth-credit-card.component';
import { AuthCustomerServiceComponent } from './authentication/auth-customer-service/auth-customer-service.component';
import { AuthEndProcessComponent } from './authentication/auth-end-process/auth-end-process.component';
import { AuthPermanentPasswordComponent } from './authentication/auth-permanent-password/auth-permanent-password.component';
import { AuthUserActivationComponent } from './authentication/auth-user-activation/auth-user-activation.component';
import { AuthValidateDetailsComponent } from './authentication/auth-validate-details/auth-validate-details.component';
import { ModalConfig } from 'hsg/lib/modal/modal.config';
import { AuthOpenCallsComponent } from './authentication/auth-open-calls/auth-open-calls.component';
import { ServerResponse } from './authentication/constants/server-response.model';
import { EndProcessMessage } from './authentication/constants/end-process-message.model';
import { AuthUserService } from './authentication/auth-user.service';
import { AuthSuccessRegistrationComponent } from './authentication/auth-success-registration/auth-success-registration.component';
import { AuthLoaderComponent } from './authentication/auth-loader/auth-loader.component';
import { environment } from '../environments/environment';
import { AuthStrictIdChoiceComponent } from './authentication/auth-strict-id-choice/auth-strict-id-choice.component';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  private _redirect: string = "/personal-info";
  public isProdMode: boolean = environment.production;
  private config: ModalConfig = {
    disableClose: false,
    disabeCloseByX: false,
    disableCloseByBg: true,
    showConfirm: true,
  }

  constructor(private modalService: ModalService, private authUserService: AuthUserService) {
    if (this.isShowLogin) {
      let source = this.getUrlParameter("Source");
      if (source) {
        this._redirect = source;
      }
      sessionStorage.setItem("loginOriginAction", "Personal Info Page")
      this.modalService.open(AuthUserDetailsComponent, this.config);
    }
  }

  @HostListener('window:message', ["$event"]) onMessage(event) {
    if(event.data.id=="CustomerRouting")
    {
    this._redirect=event.data.source;
    this.modalService.open(AuthUserDetailsComponent, this.config);
    }
    //console.log("angular-received-postmessage", event.data);
    if (event.data.Details) {
      event.data["data"] = event.data["Details"];
      delete event.data["Details"];
      this.handleServerResponse(event.data);
    }
  }
  ngOnInit(): void {
    sessionStorage.removeItem("currentWindow");
    this.modalService.subscribeToClose((res) => {
      try {
        //console.log("server-response", res);
        if (res.closeReason == ModalcloseReason.action) {
          this.handleServerResponse(res);
        } else if (res.closeReason == ModalcloseReason.confirm) {
          const currentWindow = sessionStorage.getItem("currentWindow");
          const endProccessElasticCode = sessionStorage.getItem("elasticCode");
          //this.modalService.data["CurrentProcess"] this caused  the code to "fly"
          if (window["dataLayer"] !== undefined && this.modalService.data != undefined) {
            window["dataLayer"].push({
              GA_EventCategory: "Login and Registrarion",
              GA_EventAction: "Login process stopped - By User",
              GA_EventLabel: `Screen Name = ${currentWindow} - ${sessionStorage.getItem("loginOriginAction")}`,
              event: 'GTM event To GA'
            });
          }
          //report end login proccess to action log
          this.authUserService.sendAuthData("EndProcess", { EndProcessScreen: currentWindow })
            .subscribe(() => console.log("Reporting to server-EndProcess", currentWindow));
          //report end login proccess  elastic log 
          if (endProccessElasticCode) {
            this.authUserService.sendAuthData("ElasticLogger", { elasticCode: endProccessElasticCode })
              .subscribe(res => console.log(`sent elasticLog code:${endProccessElasticCode} - close window`, res));
          }
        }
      }
      catch (error) {
        console.log("subsciber error");
      }
    })
  }
  private handleServerResponse(res: any) {

    //save current user data
    if (res.data.ProcessSuccess == ServerResponse.USER_LOGGED_IN_SUCCESS && res.data.current){
      sessionStorage.setItem("CurrentUserDetails", JSON.stringify(res.data.current));
    }

    if (res.data.ProcessError == ServerResponse.VALIDATE_DETAILS) {
      this.modalService.open(AuthValidateDetailsComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessError == ServerResponse.PASSWORD_USER_LOCKED) {
      this.modalService.open(AuthEndProcessComponent, { ...this.config, data: EndProcessMessage.PASSWORD_USER_LOCKED });
    }
    else if (res.data.ProcessSuccess == ServerResponse.OTP_SENT) {
      this.modalService.open(AuthUserOtpComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessSuccess == ServerResponse.REGISTRATION_SUCCESS) {
      this.modalService.open(AuthSuccessRegistrationComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessSuccess == ServerResponse.IDENTIFICATION_TYPE) {
      this.modalService.open(AuthAuthenticateMethodComponent, this.config);
    }
    else if (res.data.ProcessSuccess == ServerResponse.PERMANENT_PASSWORD) {
      this.modalService.open(AuthPermanentPasswordComponent, this.config);
    }
    else if (res.data.ProcessSuccess == ServerResponse.CHANGE_PASSWORD) {
      this.modalService.open(AuthChangePasswordComponent, this.config);
    }
    else if (res.data.showDecleration == ServerResponse.SHOW_DECLERATION) {
      this.modalService.open(AuthUserActivationComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessError == ServerResponse.ALREADY_EXIST) {
      this.modalService.open(AuthEndProcessComponent, { ...this.config, data: { ...EndProcessMessage.ALREADY_EXIST, ...res.data ,showContactCall: false } });
    }
    else if (res.data.ProcessError == ServerResponse.USER_IS_BLOCKED) {
      this.modalService.open(AuthEndProcessComponent, { ...this.config, data: { ...EndProcessMessage.USER_BLOCKED, showContactCall: true } });
    }
    else if (res.data.ProcessSuccess == ServerResponse.NEED_DETAILS) {
      this.modalService.open(AuthCustomerServiceComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessSuccess == ServerResponse.REQUEST_CEATED) {
      this.modalService.open(AuthEndProcessComponent, { ...this.config, data: { ...res.data, ...EndProcessMessage.CUSTOMER_SERVICE, showContactCall: false } });
    }
    else if (res.data.TechnicalError) {
      this.modalService.open(AuthEndProcessComponent, { ...this.config, data: EndProcessMessage.TECHNICAL_ERROR });
    }
    else if (res.data.ProcessSuccess == ServerResponse.ISSUE_DATE) {
      this.modalService.open(AuthIssueDateComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessSuccess == ServerResponse.FULL_STRICT || res.data.ProcessSuccess == ServerResponse.CREDIT_CARD) {
      this.modalService.open(AuthCreditCardComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ProcessSuccess == ServerResponse.CHOICE_STRICT) {
      this.modalService.open(AuthStrictIdChoiceComponent, { ...this.config, data: res.data });
    }
    else if (res.data.ClientHasOpenCalls == ServerResponse.HAS_OPEN_CALLS) {
      this.modalService.open(AuthOpenCallsComponent, { ...this.config, disabeCloseByX: true });
    }
    else if (res.data.ClientHasOpenCalls == ServerResponse.HAS_NOT_OPEN_CALLS) {
      this.modalService.open(AuthLoaderComponent, null);
      window.location.href = this._redirect;
    }
    else if (res.data.redirect == ServerResponse.REDIRECT) {
      this.modalService.open(AuthLoaderComponent, null);
      window.location.href = this._redirect;
    }
    else {
      this.modalService.open(AuthEndProcessComponent, { ...this.config, data: EndProcessMessage.TECHNICAL_ERROR });
    }
  }
  get isShowLogin(): boolean {
    return window.location.search.indexOf("isshowlogin=true") != -1;
  }
  private getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };
  openLoginModal(): void {
    this.modalService.open(AuthUserDetailsComponent, this.config);
  }
  openIssueDateModal() {
    this.modalService.open(AuthIssueDateComponent, { ...this.config, data: { CurrentProcess: 2 } });
  }
  openAuthMethodModal() {
    this.modalService.open(AuthAuthenticateMethodComponent, this.config);
  }

  openChangePasswordModal() {
    this.modalService.open(AuthChangePasswordComponent, this.config);
  }
  openCreditCardModal() {
    this.modalService.open(AuthCreditCardComponent, this.config);
  }
  openCustomerServiceModal() {
    this.modalService.open(AuthCustomerServiceComponent, { ...this.config, data: { CustomerServiceReason: '99' } });
  }
  openEndprocessModal() {
    this.modalService.open(AuthEndProcessComponent, { ...this.config, data: { ...EndProcessMessage.CUSTOMER_SERVICE, showContactCall: false } });
  }
  openPermanentpasswordeModal() {
    this.modalService.open(AuthPermanentPasswordComponent, this.config);
  }
  openActivationModal() {
    this.modalService.open(AuthUserActivationComponent, { ...this.config, data: { CurrentProcess: 'openActivationModal' } });
  }
  openValidateDetailsModal() {
    this.modalService.open(AuthValidateDetailsComponent, { ...this.config, data: { UserId: 'dddd', FullPhone: '2323232', DetailsValidationCount: '1' } });
  }
  openOtpModal() {
    sessionStorage.setItem("loginOriginAction", "openOtpModal");
    this.modalService.open(AuthUserOtpComponent, { ...this.config, data: { OTPCheckCount: "1" } });
  }
  closeOpenCallsModal() {
    this.modalService.open(AuthOpenCallsComponent, { ...this.config, disabeCloseByX: true });
  }
  openSuccessModal() {
    this.modalService.open(AuthSuccessRegistrationComponent, { ...this.config, data: { a: 1 } });
  }
  openLoaderModal() {
    this.modalService.open(AuthLoaderComponent, null);
    window.location.href = "http://google.com"
  }
  openStrictIdChoice(){
    this.modalService.open(AuthStrictIdChoiceComponent, this.config);
  }
}